import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useReadBigBag } from "../../standAloneProcess/hook/useReadBigBag";

const ReworkProductDetailReadBB = (props) => {
  const { t } = useTranslation();
  const { goBack, onSave, outPoints, type } = props;
  const [selectedOutPoint, setSelectedOutPoint] = useState(null);
  const { simpleReadBigBag, initial } = useReadBigBag();

return (
  <div className="row">

    <div className="col-12">
      <div className="col-12">{simpleReadBigBag(true)}</div>
    </div>

    <div className="col-12">
      {type === "OUT" ? (
        <div className="mb-4 text-center">
          <p>Elige un punto de salida</p>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            {outPoints.map((point, index) => (
              <div
                key={index}
                onClick={() => setSelectedOutPoint(point.uuid)}
                className={`border rounded px-3 py-2 ${
                  selectedOutPoint === point.uuid
                    ? "bg-info"
                    : "bg-light"
                }`}
                role="button"
              >
                {t(point.name)}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>

    <div className="col-12 d-flex justify-content-center mt-4">
      <button
        type="button"
        className="btn btn-lg btn-secondary"
        onClick={() => goBack(true)}
      >
        {t("forms.reworkProduct.buttons.backReworkProductDetail")}
      </button>

      <button
        type="button"
        className="btn btn-lg btn-primary mx-3"
        onClick={() => {
          onSave({
            ...initial,
            outPoint: selectedOutPoint
          });
        }}
      >
        {t("forms.reworkProduct.buttons.add")}
      </button>
    </div>

  </div>
);
};

export default ReworkProductDetailReadBB;
